module.exports = __webpack_public_path__ + "img/testimonial-sylvia.c62b917d.png";